import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import { FaTag } from 'react-icons/fa';
import { swalMessages } from '@auteco/constants';
import ZoneCreateComponent from '../../components/polygons/ZoneCreateComponent';
import { Context } from '../../context/Contex';
import PolygonsTable from '../../components/sharedComponents/Tablas'
import polygonsService from '../../services/polygonsService'
import { permitsList } from '../../constants/permits';
import CardTitle from '../../components/sharedComponents/CardTitle';

const ZoneContainer = () => {

  const [data, setData] = useState('');
  const [init, setInit] = useState('');

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false)

  const history = useHistory()
  const { unidad, permisos } = useContext(Context);

  const dataTable = []

  /*= =======================================================================
  Get Zonas
======================================================================== */

  const getZones = () => {
    setLoading(true)
    polygonsService.getZonas(unidad)
      .then((response) => {
        setData(response.data.data);
        setLoading(false)
      })
      .catch((error) => {
        console.log(error)
        setLoading(false)
        history.push('/login');
      });
  }
  useEffect(() => {
    getZones()
  }, []);

  /*= =======================================================================
  Eliminar Zonas
======================================================================== */
  const handleDelete = ({ rowData }) => {
    swal(swalMessages.DELETE_CONFIRM)
      .then((willDelete) => {
        if (willDelete) {
          polygonsService.deleteZonas(rowData.id)
            .then((response) => {
              if (response.data.id === 0) {
                swal(swalMessages.DELETE_ERROR)
              } else {
                getZones();
              }
            })
            .catch((error) => {
              console.log(error)
            });
        }
      });
  };

  /*= =======================================================================
  Crear Zonas
======================================================================== */
  const handleCreate = (params) => {
    const body = { ...params, unidad_negocio_id: unidad }
    polygonsService.postZona(body)
      .then((response) => {
        if (response.data.id === 0) {
          swal(swalMessages.ASSIGNMENT_ESTABLICHED)
        } else { getZones(); }
      })
      .catch((error) => {
        console.log(error)
      });

  };

  /*= =======================================================================
  Editar Zonas
======================================================================== */
  const handleUpdate = (params) => {
    polygonsService.putZona(params)
      .then((response) => {
        if (response.data.id === 0) {
          swal(swalMessages.ASSIGNMENT_ESTABLICHED)
        } else {
          swal(swalMessages.SUCCESSFUL_MESSAGE)
          getZones();
          setShow(false);
        }
      })
      .catch((error) => {
        console.log(error)
      });
  };

  /*= =======================================================================
 Modal Zonas
======================================================================== */
  const OpenModal = ({ rowData }) => {
    setShow(true);
    setInit(rowData);
  };

  const columns = [
    { title: 'Color', field: 'color' },
    { title: 'Nombre', field: 'name' },
    { title: 'id', field: 'id' },
    { title: 'Unidad de negocio ', field: 'unit' },
  ];

  if (data) {
    try {
      data.forEach((zones) => {
        dataTable.push({
          name: zones.zona,
          id: zones.id,
          unit: zones.unidad_negocio_id,
          color: zones.color ? <FaTag alt='nophoto' style={{ fontSize: 20, color: `${zones.color}` }} /> : zones.color,
        });
      });
    } catch (err) { console.log(err) }
  }

  return (
    <>
      <CardTitle
        title='Zonas - Edición y Creación'
      />
      <ZoneCreateComponent
        unidad={unidad}
        permisos={permisos}
        onSubmit={handleCreate}
        open={show}
        show={show}
        init={init}
        handleClose={() => setShow(false)}
        onSubmitEdit={handleUpdate}
        idPermiso={permitsList.ADMIN_ZONAS}
      />
      <PolygonsTable
        columns={columns}
        dataTable={dataTable}
        idPermisoTabla={permitsList.ADMIN_ZONAS}
        onDeleteTable={handleDelete}
        onClickEdit={OpenModal}
        titleTable='Zonas'
        hiddenEdit={false}
        hiddenDelete={false}
        loading={loading}
      />
    </>
  );

};

export default ZoneContainer;
